<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'"
            ref="content">
            <Row style="margin-bottom: 20px">
                <label>项目名称</label>
                <Select v-model="filter.projId"
                    clearable
                    placeholder="全部"
                    :disabled="loading"
                    :class="preCls + 'select-public-style'"
                    @on-change="search">
                    <Option v-for="(item, index) in projList"
                        :key="index"
                        :value="item.id">{{item.projName}}</Option>
                </Select>
                <label>开始日期</label>
                <date-picker v-model="startDate"
                    clearable
                    :disabled="loading"
                    :class="preCls + 'select-public-style'"
                    transfer
                    type="date"
                    @on-change="search"></date-picker>
                <label>结束日期</label>
                <date-picker v-model="endDate"
                    clearable
                    :disabled="loading"
                    :class="preCls + 'select-public-style'"
                    transfer
                    type="date"
                    @on-change="search"></date-picker>
                <check-tag-group style="display: inline-block;"
                    v-model="near"
                    color="primary"
                    @on-change="search">
                    <check-tag v-for="(item, index) in nearList"
                        style="height: 32px; line-height: 32px"
                        :name="item.id"
                        :key="index">{{item.text}}</check-tag>
                </check-tag-group>
            </Row>
            <table-tool-bar>
                <Button :class="preCls + 'button-margin'"
                    :disabled="loading"
                    type="primary"
                    @click="toExport">导出Excel</Button>
            </table-tool-bar>
            <Table ref="mt"
                :columns="columns"
                :data="list"
                :loading="loading"
                :height="mtHeight">
                <template v-slot:action="{ row }">
                    <Button size="small"
                        :disabled="loading"
                        @click="showInfo(row)">详情</Button>
                </template>
            </Table>
            <!-- 底部分页 -->
            <table-pager :total.sync="page.total"
                :pageSize.sync="page.pageSize"
                :pageNo.sync="page.page"
                @change="fetch"></table-pager>
            <smart-modal v-model="showOrderInfo"
                :title="orderId?'订单详情':'新增订单'"
                :width="800"
                :height="590"
                :maskClosable="false"
                @close-by-confirm="fetch"
                :buttons="buttons">
                <order-form v-if="showOrderInfo"
                    :id="orderId"></order-form>
            </smart-modal>
        </div>
    </div>
</template>
<script>
import { projList } from '@/api/proj-manager'
import { orderList } from '@/api/order-info'
import { mapCell, pipeCell } from '_c/grid/renderCell'
import Dict from '@/utils/dict'
import dayjs from 'dayjs'
import OrderForm from './form'

export default {
    components: { OrderForm },
    data() {
        return {
            projList: [],
            list: [],
            mtHeight: 200,
            filter: {
                projId: this.$cache.projId,
                startDate: this.$cache.startDate || dayjs().format("YYYY-MM-DD"),
                endDate: this.$cache.endDate || dayjs().format("YYYY-MM-DD"),
            },
            page: {
                page: 1,
                pageSize: 20,
                total: 0
            },
            nickName: '',
            loading: false,
            nearList: [{
                    id: 7,
                    text: '近7天'
                },
                {
                    id: 30,
                    text: '近30天'
                },
                {
                    id: 90,
                    text: '近90天'
                }
            ],
            orderId: '',
            showOrderInfo: false,
            dict: {
                orderStatus: Dict.NULL
            },
            buttons: [{ type: 'default', text: '关闭', name: 'cancel' }]
        }
    },
    computed: {
        columns() {
            return [{
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60
                },
                {
                    key: 'orderNumbers',
                    title: '订单号',
                    align: 'left',
                    minWidth: 150
                },
                {
                    key: 'price',
                    title: '秒杀价(元)',
                    align: 'right',
                    minWidth: 150,
                    render: pipeCell('currency')
                },
                {
                    key: 'houseName',
                    title: '房号',
                    align: 'left',
                    minWidth: 150
                },
                {
                    key: 'buyTime',
                    title: '认购时间',
                    align: 'left',
                    minWidth: 150,
                    render: pipeCell('ymdL')
                },
                {
                    key: 'orderStatus',
                    title: '状态',
                    align: 'center',
                    minWidth: 150,
                    render: mapCell(this.dict.orderStatus.val())
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    slot: 'action',
                    minWidth: 80
                }
            ]
        },

        startDate: {
            get() {
                return this.filter.startDate ? new Date(this.filter.startDate) : ''
            },
            set(val) {
                this.filter.startDate = val ? dayjs(val).format("YYYY-MM-DD") : ''
            }
        },

        endDate: {
            get() {
                return this.filter.endDate ? new Date(this.filter.endDate) : ''
            },
            set(val) {
                this.filter.endDate = val ? dayjs(val).format("YYYY-MM-DD") : ''
            }
        },

        near: {
            get() {
                return [dayjs(this.filter.endDate).diff(this.filter.startDate, 'day')]
            },
            set(val) {
                let days = val[0]

                if (days) {
                    this.filter.endDate = dayjs().format('YYYY-MM-DD')
                    this.filter.startDate = dayjs()
                        .subtract(days, 'day')
                        .format('YYYY-MM-DD')
                }
            },
        }
    },

    watch: {
        "filter.projId": function(el) {
            this.$cache.projId = el
        },
        "filter.startDate": function(el) {
            this.$cache.startDate = el
        },
        "filter.endDate": function(el) {
            this.$cache.endDate = el
        },
    },

    methods: {
        fetch() {
            this.loading = true
            let body = {
                page: this.page.page,
                pageSize: this.page.pageSize
            }
            Object.assign(body, this.filter)
            orderList(body)
                .then(res => {
                    this.page.total = parseInt(res.data.page.totalCount)
                    this.list = res.data.page.list
                })
                .finally(() => (this.loading = false))
        },
        search() {
            this.page.pageNo = 1
            this.fetch()
        },
        checkProj() {
            this.$cache.projId = this.filter.projId
            this.fetch()
        },
        addOrder() {
            this.orderId = ''
            this.showOrderInfo = true
        },
        showInfo(row) {
            this.orderId = row.id
            this.showOrderInfo = true
        },
        toExport() {
            let filter = Object.assign({}, this.filter)
            Object.assign(filter, {
                pageNo: 1,
                pageSize: 9999
            })

            let headers = JSON.parse(
                JSON.stringify(this.columns.filter(el => el.key != 'action'))
            )
            headers.forEach(el => {
                el.width = 300
            })

            orderList(filter).then(res => {
                let list = res.data.page.list
                list.forEach(el => {
                    el.buyTime = el.buyTime ?
                        dayjs(el.buyTime).format('YYYY-MM-DD HH:mm:ss') :
                        ''
                    el.orderStatus = el.orderStatus ?
                        this.dict.orderStatus.val(el.orderStatus) :
                        ''
                })
                this.$refs.mt.exportToExcel({
                    filename: `订单列表_${dayjs().format('YYYYMMDDHHmmss')}`,
                    rows: list,
                    headers
                })
            })
        }
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
        this.loading = true

        let body = {
            page: 1,
            pageSize: 999
        }

        Promise.all([projList(body), Dict.get(['order_status'])])
            .then(args => {
                let [proj, dict] = args
                this.projList = proj.data.page.list
                Object.keys(this.dict).forEach(key => {
                    this.dict[key] = dict[key]
                })
            })
            .finally(() => this.fetch())
    }
}
</script>
<style lang="less"
    scoped>
</style>